export const getClinicTabData = (): {
  isFromClinicTab: boolean;
  closeRedirectUrl: string;
} => {
  try {
    const clinicTabData = sessionStorage.getItem("clinicTabData");
    const { isFromClinicTab, closeRedirectUrl } =
      JSON.parse(clinicTabData || "{}") || {};

    return {
      isFromClinicTab: isFromClinicTab === "true",
      closeRedirectUrl
    };
  } catch {
    return {
      isFromClinicTab: false,
      closeRedirectUrl: ""
    };
  }
};
